import PageLayout from "../../components/common/page-layout";
import SchemaList from "../../components/doc-scanning/schema-list/schema-list";
import DocScanningMatchingProgress from "../../components/doc-scanning/schema-testing/job-progress/doc-scanning-job-progress";
import { RequireAuth } from "../../hooks/use-auth";

/**
 * The legacy schema-matching schema list: search schemas, map them to
 * companies, and kick off a bulk match. The bulk-match dock is mounted here
 * because this is where a match is started, and again on the schema editor
 * because that is where its results are followed up.
 */
const SchemaListPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        disableGutters
        maxWidth={false}
        subtitle="Legacy schema-matching pipeline"
        title="Schema list"
      >
        <SchemaList />
        <DocScanningMatchingProgress />
      </PageLayout>
    </RequireAuth>
  );
};

export default SchemaListPage;
